/* ROXARI: deter casual right-click saving/dragging of storefront images. */
(() => {
  'use strict';
  function isStorefrontImage(target) {
    return target instanceof Element && !!target.closest('#MainContent img, .pswp__img');
  }
  document.addEventListener('contextmenu', (event) => {
    if (isStorefrontImage(event.target)) event.preventDefault();
  }, { capture: true });
  document.addEventListener('dragstart', (event) => {
    if (isStorefrontImage(event.target)) event.preventDefault();
  }, { capture: true });
})();
